import { RerunReasonType, TestResultRunStatus } from "./enums";

export class TestResultRunHistoryItem {
    RunNumber: number;
    Status: TestResultRunStatus;
    RequestDateTime: Date;
    Reason?: RerunReasonType;
    OtherReasonText: string;
    Comment: string;
    AccessionNumber: string;
    AnalyzerId?: number;
}
